// extracted by mini-css-extract-plugin
export var one = "styles-module--one--2LYyS";
export var grid = "styles-module--grid--1Eo0t";